import type { QueryClient } from '@tanstack/react-query';
import { refreshQueries } from '../refresh';
import { EVENTS_KEY } from './labels';

/** After any write to events (see `refreshQueries` for why a plain invalidate is not enough). */
export const refreshEvents = (queryClient: QueryClient): Promise<void> => refreshQueries(queryClient, EVENTS_KEY);
